import {createRouter, createWebHistory} from 'vue-router'
import MainLayout from "@/layouts/MainLayout.vue";
import NotFoundView from "@/views/NotFoundView.vue";
/*import {inject} from "vue";
import {requestHttp} from "@/services/HttpRequest";*/

const routes = [
    {
        path: '/',
        name: 'mainLayout',
        component: MainLayout,
        children: [
            {

                path: '/',
                name: 'tyc',
                meta: {public: true},
                component: () => import( '../views/UltimosTerminosYcondicionesView.vue')

            }, {
                path: 'terminos-condiciones',
                name: 'terminos-condiciones',
                meta: {public: true},
                component: () => import('../views/UltimosTerminosYcondicionesView.vue')
            },

        ],

    },
    {path: '/:pathMatch(.*)*', name: 'notFount', component: NotFoundView},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

/*
router.beforeEach(async (to, from, next) => {
    const rootScope = inject('rootScope')
    if (to.query.token) {
        const token = to.query.token;
        if (to.query.id) {
            rootScope.reference_id = to.query.id;
            rootScope.whatsapp = true;
        }

        // Guardar en localStorage
        localStorage.setItem('token', token);
        console.log('Token encontrado en URL:', token);

        // Opcional: Redirigir a factura sin el token en la URL
        // para evitar que quede visible
        if (to.name === 'home') {
            next({name: 'home', query: {}});
            return;
        }
    }

    try {

        rootScope.loading = true;
        const response = await requestHttp({
            endpoint: "auth/authStatus",
        });

        rootScope.loading = false;
        const data = response.data;


        if (data.estado === 400) {
            rootScope.logged = false;
            rootScope.name = "";
            rootScope.user = 0;
            /!*if ( to.name !== 'login' && to.name !== 'register' && to.name !== 'forgot-password') {
                next({name: 'login'});
            } else next();*!/

            if (to.meta?.public) {
                next();
            } else {
                next({name: 'login'});
            }
        } else if (data.estado === 200) {
            const datosSession = data.data;
            rootScope.logged = datosSession.logueado;
            rootScope.name = datosSession.nombre;
            rootScope.user = datosSession.usuario;
            rootScope.saldo_creditos = datosSession.valor_creditos;
            rootScope.saldo_acumulado = datosSession.valor_acumulado;
            rootScope.registro_completo = datosSession.registro_completado;
            rootScope.termidoId = datosSession.termino_id;
            rootScope.rutaTyC = datosSession.ruta_tyc;

            /!*   if (to.name !== 'password-change' && datosSession.restablecer_clave === 0) {
                   next({name: 'password-change'});
               }*!/

            if (datosSession.validar_terminos && to.name !== "aceptar-terminos-condiciones") {

                next({name: 'aceptar-terminos-condiciones'});
            } else if (!datosSession.validar_terminos && to.name === "aceptar-terminos-condiciones") {
                next({name: 'login'});
            }

            if (to.name === 'login' || to.name === 'register') {
                next({name: 'home'});
            } else {
                next();
            }

        } else {
            rootScope.logged = false;
            localStorage.removeItem('token');
            next({name: 'login'});
        }

    } catch (error) {
        localStorage.removeItem('token');
        rootScope.logged = false;
        rootScope.loading = false;
        next({name: 'login'});
    }

});
*/

export default router
